import { render, staticRenderFns } from "./calcVesselsSpeedResultRow.vue?vue&type=template&id=18766d78&scoped=true"
import script from "./calcVesselsSpeedResultRow.vue?vue&type=script&lang=js"
export * from "./calcVesselsSpeedResultRow.vue?vue&type=script&lang=js"
import style0 from "./calcVesselsSpeedResultRow.vue?vue&type=style&index=0&id=18766d78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18766d78",
  null
  
)

export default component.exports